import * as logos from "styles/logos";
import type { LogoProps } from "./Logo.d";

const Logo = ({ logo, logoWidth, color }: LogoProps) => {
  const Component = logos[logo];
  return <Component color={color} w={`${logoWidth}px`} h="auto" />;
};

export default Logo;
